import { UserService } from '@core/services/user/user.service';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { SIMPLE_EVENTS } from '@core/utils/utils';
import { HostListener, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { Component, Input } from '@angular/core';
import { slideInFromRight } from '@ebcont/ebcont.galaxy.js';

@Component({
  selector: 'app-list-page',
  templateUrl: './list-page.component.html',
  styleUrl: './list-page.component.scss',
  standalone: false,
  animations: [slideInFromRight]
})
export class ListPageComponent {
  @Output() public downloadList: EventEmitter<void> = new EventEmitter();

  @Input() headline = '';
  @Input() subheadline = '';
  @Input() detailsLoaded = false;
  @Input() buttonReenableDelay = 3000;

  public isAdmin = false;
  protected readonly csvExportIcon = faDownload;
  public listIsDownloading = false;
  private downloadCompleteTimeout: any;

  constructor(
    private readonly userService: UserService,
    private cd: ChangeDetectorRef
  ) {
    this.userService.getAdminStatus().subscribe((isAdmin) => {
      this.isAdmin = isAdmin;
    });
  }

  public clickOnDownloadList() {
    this.listIsDownloading = true;
    this.cd.detectChanges();
    this.downloadList.emit();
  }

  @HostListener(`document:${SIMPLE_EVENTS.DOWNLOAD_COMPLETED}`, ['$event'])
  protected downloadCompleted(): void {
    if (this.downloadCompleteTimeout) {
      clearTimeout(this.downloadCompleteTimeout);
    }

    // timeout to re-enable button after delay
    this.downloadCompleteTimeout = setTimeout(() => {
      this.listIsDownloading = false;
      this.downloadCompleteTimeout = null;
      this.cd.detectChanges();
    }, this.buttonReenableDelay);
  }

  // clean up timeout
  ngOnDestroy(): void {
    if (this.downloadCompleteTimeout) {
      clearTimeout(this.downloadCompleteTimeout);
      this.downloadCompleteTimeout = null;
    }
  }
}
